import Link from 'next/link'
import styled from 'styled-components'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { useGetRafflesQuery } from 'api/rafflesApi'
import { t } from 'localization'
import { isRaffleVisible } from './raffleUtils'
import { H6 } from 'shared/text'

const TP = 'shared.components.Raffles.MobileNavRaffles'

export const MobileNavRaffles = () => {
  const isRafflesEnabled = useFeatureFlag(FeatureFlag.TEMP_WEB_FC_ENABLE_RAFFLES)
  const { data: raffles } = useGetRafflesQuery(undefined, {
    skip: !isRafflesEnabled,
  })

  const displayRaffles = raffles?.filter(isRaffleVisible) ?? []

  if (!isRafflesEnabled || displayRaffles.length === 0) return null

  return (
    <Section data-qa="mobile-nav-raffles">
      <Title>{t(`${TP}.sneakerRaffles`, 'Sneaker Drawings')}</Title>
      {displayRaffles.map((raffle) => (
        <Link key={raffle.slug} href={`/drawings/${raffle.slug}`} passHref legacyBehavior>
          <RaffleLink data-qa="mobile-nav-raffle-link">
            {raffle.productName} {t(`${TP}.raffle`, 'Drawing')}
          </RaffleLink>
        </Link>
      ))}
    </Section>
  )
}

const Section = styled.div`
  padding: 24px;
`

const Title = styled(H6)`
  margin-bottom: 20px;
`

const RaffleLink = styled.a`
  color: unset;
  cursor: pointer;
  display: block;
  font-size: 16px;
  line-height: 20px;
  padding: 10px 0;
  text-decoration: none;
`
